import React from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import EditPartnerForm from './editPartnerForm';

const EditPartner = () => {
    const componentSteps = [
        {
            title: 'Select Partner',
            content: <GetInfo isPartner={true} placeHolder='Please select the partner' />,
            id: 0,
        },
        {
            title: 'Edit partner',
            content: <EditPartnerForm />,
            id: 1
        },
    ];

    return (
        <div className='create-merchant'>
            <Stepper componentSteps={componentSteps} />
        </div>
    );
};

export default EditPartner;
